import { hotTags } from '@/mocks/site';

export default function HotTopicsBar() {
  return (
    <section id="hot" className="bg-background-100 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
        <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide">
          <span className="flex items-center gap-1.5 text-sm font-semibold text-primary-600 whitespace-nowrap">
            <i className="ri-fire-line"></i>
            热门话题
          </span>
          <div className="flex gap-2 flex-wrap">
            {hotTags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1.5 text-xs font-medium bg-background-50 text-foreground-700 rounded-full border border-background-200/70 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                #{tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}